// components/GallerySection/GallerySection.jsx
import React, { useEffect, useMemo, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import { motion } from 'framer-motion';
import axios from 'axios';
import { API_BASE } from '../config/api';

// Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import './css/GallerySection.css';

import FirstImg from './images/2.jpg';
import SecondImg from './images/1.jpg';

const GallerySection = () => {
  const defaultGallery = useMemo(
    () => ({
      marquee_text:
        '* استشارات بحثية * توجيه أكاديمي * تمكين الباحثات * خبرة واقعية * دعم نفسي *',
      slide1_overlay_text: 'جلسات استشارية',
      slide2_overlay_text: 'دعم الباحثات',
      slide3_overlay_text: 'مصادر علمية',
      slide1_image_url: null,
      slide2_image_url: null,
      slide3_image_url:
        'https://images.unsplash.com/photo-1434030216411-0b793f4b4173?q=80&w=1000&auto=format&fit=crop',
    }),
    []
  );

  const [gallery, setGallery] = useState(defaultGallery);

  useEffect(() => {
    let mounted = true;
    axios
      .get(`${API_BASE}/api/gallery`)
      .then((res) => {
        const db = res.data?.gallery;
        if (!mounted) return;
        setGallery(db ? { ...defaultGallery, ...db } : defaultGallery);
      })
      .catch((err) => {
        console.error('Failed to load gallery:', err);
        if (!mounted) return;
        setGallery(defaultGallery);
      });

    return () => {
      mounted = false;
    };
  }, [defaultGallery]);

  const toAbsoluteImageUrl = (maybeUrl) => {
    if (!maybeUrl) return '';
    const u = String(maybeUrl).trim();
    if (!u) return '';
    if (u.startsWith('http://') || u.startsWith('https://')) return u;
    // DB stores relative like "/uploads/gallery/..."
    return `${API_BASE}${u}`;
  };

  const img1 = gallery.slide1_image_url ? toAbsoluteImageUrl(gallery.slide1_image_url) : FirstImg;
  const img2 = gallery.slide2_image_url ? toAbsoluteImageUrl(gallery.slide2_image_url) : SecondImg;
  const img3 = gallery.slide3_image_url ? toAbsoluteImageUrl(gallery.slide3_image_url) : defaultGallery.slide3_image_url;

  const marqueeText = gallery.marquee_text || defaultGallery.marquee_text;
  const overlay1 = gallery.slide1_overlay_text || defaultGallery.slide1_overlay_text;
  const overlay2 = gallery.slide2_overlay_text || defaultGallery.slide2_overlay_text;
  const overlay3 = gallery.slide3_overlay_text || defaultGallery.slide3_overlay_text;

  const slideItems = useMemo(
    () => [
      { image: img1, overlay: overlay1 },
      { image: img2, overlay: overlay2 },
      { image: img3, overlay: overlay3 },
    ],
    [img1, img2, img3, overlay1, overlay2, overlay3]
  );

  return (
    <section className="gallery-section" dir="rtl">
      
      {/* 1. Infinite Text Marquee */}
      <div className="marquee-wrapper">
        <div className="marquee-track">
          <span>{marqueeText}</span>
          <span>{marqueeText}</span>
        </div>
      </div>

      {/* 2. Image Slider (Replaces Video) */}
      <motion.div 
        className="container slider-container"
        initial={{ opacity: 0, scale: 0.95 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        <Swiper
          modules={[Navigation, Autoplay]}
          spaceBetween={0}
          slidesPerView={1}
          navigation
          autoplay={{ delay: 3000 }}
          loop={true}
          className="mySwiper"
        >
          {slideItems.map((s, idx) => (
            <SwiperSlide key={idx}>
              <div className="slide-content">
                <img src={s.image} alt={s.overlay} />
                <div className="play-overlay">
                  <span className="overlay-text">{s.overlay}</span>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </motion.div>

    </section>
  );
};

export default GallerySection;